/**
 * 알림 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class NotificationService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 알림 확인 처리
     * 특정 알림을 읽음 처리한다.
     * @param notificationId - 알림 ID
     * @returns 알림 확인 처리 결과
     */
    markAsChecked(notificationId) {
        return this.axios.patch(`/main/v1/notifications/${notificationId}/check`);
    }
    /**
     * 읽지 않은 알림 전체 읽음 처리
     * 사용자의 읽지 않은 모든 알림을 읽음 처리한다.
     * @returns 읽지 않은 알림 전체 읽음 처리 결과
     */
    markAllAsChecked() {
        return this.axios.patch(`/main/v1/notifications/check-all`);
    }
    /**
     * 알림 내역 목록 조회
     * 사용자의 알림 내역을 카테고리별로 조회한다. 카테고리가 없으면 전체 조회.
     * @param request - 알림 내역 목록 조회 요청 데이터
     * @returns 알림 내역 목록 조회 결과
     */
    getNotificationHistories(request) {
        return this.axios.get(`/main/v1/notifications`, {
            params: request,
        });
    }
    /**
     * 읽지 않은 알림 목록 조회
     * 사용자의 읽지 않은 알림 내역만 조회한다.
     * @param request - 읽지 않은 알림 목록 조회 요청 데이터
     * @returns 읽지 않은 알림 목록 조회 결과
     */
    getUnreadNotificationHistories(request) {
        return this.axios.get(`/main/v1/notifications/unread`, {
            params: request,
        });
    }
    /**
     * 알림 삭제
     * 특정 알림을 사용자에게서 삭제한다. 실제로는 삭제되지 않고 조회 목록에서만 제외된다.
     * @param notificationId - 알림 ID
     * @returns 알림 삭제 결과
     */
    deleteNotification(notificationId) {
        return this.axios.delete(`/main/v1/notifications/${notificationId}`);
    }
}
//# sourceMappingURL=notification.service.js.map